export const initialState = {
	bannerSliders: [],
	loading: false,
	error: '',
};